import React, {useEffect, useRef} from 'react'
import ButterflyImg from '../../assets/butterfly/butterfly.webp'
import Pearl_1 from '../../assets/butterfly/pearl_1.webp'
import Pearl from '../Pearl/Pearl'

interface WingProps {
  pearlTrigger: boolean
  wingRef: React.RefObject<HTMLDivElement>
  DefaultColorClass: string
}

const Wing: React.FC<WingProps> = ({pearlTrigger, wingRef, DefaultColorClass}) => {
  const defaultWingRef = useRef<HTMLDivElement>(null)

  useEffect(() => {
    const mediaQuery = window.matchMedia('(prefers-reduced-motion: reduce)')
    const wing = wingRef.current

    if (wing) {
      if (mediaQuery.matches) {
        wing.classList.add('noAnimation')
      } else {
        // Wing animation logic (if any) can be added here
        // The pearl animations are now handled by the Pearl component
        if (pearlTrigger) {
          wing.classList.remove('afterAnimation')
        } else {
          wing.classList.add('afterAnimation')
        }
      }
    }
  }, [pearlTrigger, wingRef])

  return (
    <div className="wing" ref={wingRef}>
      <div className="wingMask" style={{maskImage: `url(${ButterflyImg})`}}>
        <Pearl pearlTrigger={pearlTrigger} />
        <div className={`defaultColor ${DefaultColorClass}`} ref={defaultWingRef} />
      </div>
      <div className="wingBlur">
        <div
          className="wingBlurMaskPearl"
          style={{maskImage: `url(${ButterflyImg})`, backgroundImage: `url(${Pearl_1})`}}
        />
        {DefaultColorClass === 'DefaultWhiteColor' && (
          <div className="wingBlurMask" style={{maskImage: `url(${ButterflyImg})`}} />
        )}
      </div>
    </div>
  )
}

export default Wing

try{ Wing.displayName ||= 'Wing' } catch {}